import React from 'react';

const DomainCheckboxGroup = React.memo(({ title, options, selectedValues, onChange, disabled = false }) => (
    <div className="mb-4">
        <h3 className="text-md font-medium text-slate-700 mb-2">{title}</h3>
        <div className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 max-h-60 overflow-y-auto p-2 rounded-md border border-slate-300 bg-white shadow-sm ${disabled ? 'bg-slate-100 opacity-70' : ''}`}>
            {options.map(option => (
                <label key={option} className={`flex items-center space-x-2 p-1.5 hover:bg-sky-50 rounded-md transition-colors duration-150 ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
                    <input type="checkbox" className="form-checkbox h-4 w-4 text-sky-600 border-slate-400 rounded focus:ring-sky-500 focus:ring-offset-1" checked={selectedValues.includes(option)} onChange={() => !disabled && onChange(option)} disabled={disabled} />
                    <span className="text-sm text-slate-600">{option}</span>
                </label>
            ))}
        </div>
    </div>
));

export default DomainCheckboxGroup;